<template>
  <div>
    <div class="bigBox">
      <div class="workleft">
        <Form
          ref="form"
          :model="forms"
          :label-width="150"
          :disabled="action == 'view' ? true : false"
        >
          <div class="first-line">
            <p
              style="
                color: #00050e;
                font-size: 0.875rem;
                padding-top: 5px;
                text-align: left;
                width: 8%;
                display: inline-block;
                margin-right: 5px;
              "
            >
              处理内容:
            </p>
            <div class="left-01">
              <Input
                v-model="maintainerContent"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 3 }"
                placeholder="请输入或点击左侧选择"
              ></Input>
            </div>
          </div>
          <div class="first-line">
            <p
              style="
                color: #00050e;
                font-size: 0.875rem;
                padding-top: 5px;
                text-align: left;
                width: 8%;
                display: inline-block;
                margin-right: 5px;
              "
            >
              故障原因:
            </p>
            <div class="left-01">
              <Select
                class="SelectT"
                v-model="teackRemark"
                filterable
                placeholder="请选择故障原因"
                clearable="true"
              >
                <Option
                  v-for="item in teackList"
                  :value="item.descr"
                  :key="item.id"
                  >{{ item.descr }}
                </Option>
              </Select>
            </div>
          </div>
          <div class="second-line">
            <div>
              <p><span style="color: red">*</span> 科室信息:</p>
              <el-select
                class="SelectDesk"
                v-model="DepartmentValue"
                filterable
                remote
                reserve-keyword
                placeholder="请选择或搜索科室电话、名称、地址（楼宇-楼层）"
                :remote-method="remoteMethod1"
                @change="OnDepartment(DepartmentValue)"
                :loading="loading1"
              >
                <el-option
                  v-for="item in deskList"
                  :key="item.id"
                  :label="
                    item.deskName +
                    (item.address ? '/' + item.address : '') +
                    (item.phone ? '/' + item.phone : '')
                  "
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="first-line">
            <div>
              <p>设备信息:</p>
              <el-select
                class="Select"
                v-model="EquipmentValue"
                filterable
                remote
                reserve-keyword
                :remote-method="remoteMethod2"
                placeholder="请选择或搜索设备编号、类型、型号、SN号"
                clearable="true"
                :loading="loading2"
                @change="SelectEquipment(EquipmentValue)"
              >
                <el-option
                  v-for="item in EquipmentList"
                  :value="item.Num"
                  :key="item.id"
                  :label="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <p><span style="color: red">*</span>故障类型:</p>
              <Select
                class="Select"
                v-model="typeId"
                placeholder="请选择问题或故障类型"
                filterable
              >
                <Option
                  v-for="item in workList"
                  :value="item.typeId"
                  :key="item.typeId"
                  >{{ item.name }}
                </Option>
              </Select>
            </div>
          </div>
          <div class="first-line">
            <div>
              <p style="display: inline">报修人:</p>
              <Input
                class="Select"
                v-model="repairBy"
                placeholder="请输入报修人"
              ></Input>
            </div>
            <div>
              <p>报修电话:</p>
              <Input
                class="Select"
                v-model="repairPhone"
                placeholder="请输入报修电话"
              ></Input>
            </div>
          </div>
          <div class="service-line">
            <div>
              <p><span style="color: red">*</span> 服务类型:</p>
              <Select
                class="Select"
                v-model="service"
                filterable
                placeholder="请选择服务类型"
                clearable="true"
              >
                <Option
                  v-for="item in serviceList"
                  :value="item.service"
                  :key="item.service"
                  >{{ item.service }}
                </Option>
              </Select>
            </div>
          </div>
          <div class="compare-line">
            <div>
              <p style="display: inline">处理状态:</p>
              <Input class="Select" v-model="state" disabled></Input>
            </div>
          </div>
          <div class="workleft-3">
            <Button
              type="info"
              @click="handleSubmit"
              size="default"
              class="button2"
              >保 存</Button
            >
          </div>
          <!--          <div class="workleft-4">-->
          <!--            <Button-->
          <!--                type="info"-->
          <!--                @click="handleSubmitKnow"-->
          <!--                size="default"-->
          <!--                class="button2"-->
          <!--            >保存并转存知识库-->
          <!--            </Button>-->
          <!--          </div>-->
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import siblingCall from "@/utils/siblingCall";
import log from "@/api/modules/log";
export default {
  extends: baseEdit,
  components: {},
  props: {
    deskList: {},
    teackList: {},
    workList: {},
  },
  data() {
    return {
      data: [],
      data2: [],
      descr: "",
      patient: false,
      allData: [],
      typeId: "",
      descr2: "",
      allData2: [],
      serviceList: [
        {
          service: "服务类",
          lable: "服务类",
        },
        {
          service: "换修类",
          lable: "换修类",
        },
        {
          service: "新增类",
          lable: "新增类",
        },
      ],
      service: "服务类",

      DepartmentValue: "",
      EquipmentValue: "",

      single: true,
      getText: "",
      maintainerContent: "",
      programme: "",
      EquipmentList: {}, //设备列表
      engineer1: "",
      repairPhone: "",
      repairBy: "",
      mname: "work",
      teackRemark: "",

      RepairText: "",
      state: "已完成",
      key: "id",
      columns2: [
        {
          title: "处理内容",
          minWidth: 170,
          align: "left",
          key: "descr2",
        },
      ],
      url: {},
      loading1: false,
      loading2: false,
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  mounted() {},
  async created() {
    await this.loadfaultData();
    await this.deskListMethod();
    this.repairPhone = this.phone;
    await this.loadTypeData();
  },
  methods: {
    async remoteMethod1(query) {
      let d = {};
      this.loading1 = true;
      if (query !== "") {
        d.deskName = query;
      }
      console.log(query);
      let res = await $utils.api.load(
        "/admin/system/desk/selectList",
        d,
        "get"
      );
      if (res && res.rows) {
        this.loading1 = false;
        this.deskList = res.rows;
        console.log(this.deskList);
      } else {
        this.loading1 = false;
      }
    },
    async remoteMethod2(query) {
      let d = {};
      this.loading2 = true;
      if (query !== "") {
        d.facilityName = query;
      }
      let res = await $utils.api.load(
        "/admin/system/facility/selectListSearch",
        d,
        "get"
      );
      if (res && res.rows) {
        this.loading2 = false;
        let list = res.rows;
        let arr = [];
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            obj.deskId = item.deskId;
            obj.value =
              item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
            obj.Num = item.facilityNum;
            arr.push(obj);
          }
        }
        this.EquipmentList = arr;
      } else {
        this.loading2 = false;
      }
    },
    //选择设备
    async SelectEquipment(item) {
      let list = this.EquipmentList;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let a = list[i];
          if (!item) {
            await this.loadCommonData(null);
          }
          if (a.Num == item) {
            this.facilityNo = a.Num;
            this.DepartmentValue = a.deskId;
            await this.loadfaultData(this.facilityNo);
          }
        }
      }
    },
    //选择设备
    async loadfaultData(facilityNo) {
      if (facilityNo) {
        let q = {};
        q.facilityNum = facilityNo;
        let res = await $utils.api.load(
          `/admin/system/facility/workTypeHome`,
          q
        );
        console.log(4444, res);
        if (res) {
          let list = res.rows;
          if (!list || list.length === 0) {
            this.workList = {};
            this.typeId = "";
            this.getText = "";
          } else {
            this.typeId = list[0].id;
            console.log(this.typeId);
            await this.loadTypeData();
          }
        }
      }
    },

    async OnDepartment(DepartmentValue) {
      if (this.DepartmentValue) {
        // this.getText = ""
        // this.programme = ""
        this.EquipmentList = [];
        this.EquipmentValue = "";
      }
      let q = {};
      q.state = 2;
      q.deskId = DepartmentValue;
      let res = await $utils.api.load(
        "/admin/system/facility/selectList",
        q,
        "get"
      );
      let list = res.rows;
      let arr = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          let obj = {};
          obj.deskId = item.deskId;
          obj.value =
            item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
          obj.Num = item.facilityNum;
          arr.push(obj);
        }
      } else {
        this.EquipmentValue = "";
      }
      this.EquipmentList = arr;
    },
    //选择故障类型下拉框
    async loadTypeData() {
      let q = {};
      q.typeId = this.typeId;
      // 通过pk查询字典数据
      let res = await $utils.api.load("/admin/system/workType/listFrame", q);
      console.log(111, res);
      if (res && res.rows) {
        let list = res.rows;
        if (list.length > 0) {
          let lists = [];
          list.forEach((obj) => {
            lists.push({ name: obj.name, typeId: obj.id });
            if (obj.deskList && obj.deskList.length > 0) {
              obj.deskList.forEach((item) => {
                const newObj = {
                  name: `${obj.name}-${item.name}`,
                  typeId: item.id,
                };
                lists.push(newObj);
              });
            }
          });
          console.log("workTypeList", lists);
          this.workList = lists;
        }
      }
    },

    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      if (res && res.rows) {
        this.deskList = res.rows;
        for (let i = 0; i < this.deskList.length; i++) {
          let workInfotemp = "";
          if (
            this.deskList[i].deskName !== null &&
            this.deskList[i].deskName !== undefined
          ) {
            workInfotemp = this.deskList[i].deskName;
          }
          if (
            this.deskList[i].principal !== null &&
            this.deskList[i].principal !== undefined
          ) {
            workInfotemp = workInfotemp + "/" + this.deskList[i].principal;
          }
          if (
            this.deskList[i].phone !== null &&
            this.deskList[i].phone !== undefined
          ) {
            workInfotemp = workInfotemp + "/" + this.deskList[i].phone;
          }
          if (
            this.deskList[i].address !== null &&
            this.deskList[i].address !== ""
          ) {
            workInfotemp = workInfotemp + "/" + this.deskList[i].address;
          }
          this.deskList[i].deskName = workInfotemp;
        }
      }
    },

    async loadDeskData(repairPhone) {
      // 通过pk查询字典数据
      let q = {};
      q.phonenumber = repairPhone;
      let res = await $utils.api.load(`/admin/system/desk/selectUserList`, q);
      if (res && res.rows.length > 0) {
        let ll = res.rows;
        this.DepartmentValue = ll[0].id;
        await this.OnDepartment(this.DepartmentValue);
      }
    },

    handleSubmitKnow() {
      if (this.knowedgeQeck) {
        if (!this.maintainerContent) {
          $utils.toast.error("请填写处理内容");
          return;
        }
        if (!this.service) {
          $utils.toast.error("请填写服务类型");
          return;
        }
      }

      if (!this.DepartmentValue) {
        $utils.toast.error("请选择科室");
        return;
      }
      if (!this.typeId) {
        $utils.toast.error("请选择故障类型");
        return;
      }

      let q = {
        descr: this.getText,
        deskId: this.DepartmentValue,
        facilityNo: this.EquipmentValue,
        typeId: this.typeId,
        repairBy: this.repairBy,
        repairPhone: this.repairPhone,
        sendType: 2,
        maintainerId: this.maintainerId,
        isKnow: 1,
        maintainType: 2,
        callId: this.callId,
        maintainerContent: this.maintainerContent,
        teackRemark: this.teackRemark,
        service: this.service,
        repairSource: 3,
        state: 3,
      };
      if (this.callId) {
        q.repairSource = 4;
      }
      if (this.EquipmentValue) {
        q.isFastOrder = 0;
      } else {
        q.isFastOrder = 1;
      }

      this.sloading = true;

      $utils.api
        .load(
          `/admin/system/work/callCenterAdd`,
          q,
          this.action == "edit" ? "PUT" : "POST"
        )
        .then((res) => {
          this.sloading = false;
          if (res.code == 200) {
            $utils.toast.success("保存成功");
            setTimeout(() => {
              this.$Modal.remove();
              $utils.url.go(0);
            }, 1000);
          }
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
    handleSubmit() {
      if (this.knowedgeQeck) {
        if (!this.maintainerContent) {
          $utils.toast.error("请填写处理内容");
          return;
        }
        if (!this.service) {
          $utils.toast.error("请填写服务类型");
          return;
        }
      }

      if (!this.DepartmentValue) {
        $utils.toast.error("请选择科室");
        return;
      }
      if (!this.typeId) {
        $utils.toast.error("请选择故障类型");
        return;
      }
      if (!this.teackRemark) {
        $utils.toast.error("请选择故障原因");
        return;
      }
      let q = {
        descr: this.getText,
        deskId: this.DepartmentValue,
        facilityNo: this.EquipmentValue,
        typeId: this.typeId,
        repairBy: this.repairBy,
        repairPhone: this.repairPhone,
        sendType: 2,
        maintainerId: this.maintainerId,
        isKnow: 0,
        maintainType: 2,
        callId: this.callId,
        maintainerContent: this.maintainerContent,
        teackRemark: this.teackRemark,
        service: this.service,
        repairSource: 3,
      };
      if (this.callId) {
        q.repairSource = 4;
      }
      if (this.EquipmentValue) {
        q.isFastOrder = 0;
      } else {
        q.isFastOrder = 1;
      }
      q.state = 3;
      this.sloading = true;
      $utils.api
        .load(`/admin/system/work/callCenterAdd`, q, "POST")
        .then((res) => {
          this.sloading = false;
          if (res.code == 200) {
            $utils.toast.success("保存成功");
          }
          setTimeout(() => {
            this.$Modal.remove();
            $utils.url.go(0);
          }, 1000);
        })
        .catch((e) => {
          this.sloading = false;
          $utils.toast.error("保存异常" + e.message);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.bigBox {
  height: calc(667px);
  margin-top: 17px;
  display: flex;
  justify-content: space-between;

  .workleft {
    width: 100%;
    margin-left: 1%;

    .radio-work {
      margin-left: 100px;
    }

    h3 {
      margin-bottom: 10px;
    }

    .first-line {
      margin-top: calc(20px);
      width: calc(100%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100.2%;

        .SelectT {
          width: 100%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        .Select {
          width: 83%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 16.7%;
          display: inline-block;
          margin-right: 5px;
        }
      }

      .left-01 {
        display: inline-block;
        width: 90.5%;

        vertical-align: top;

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: calc(25%);
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: 90.7%;
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        height: 100px;
        overflow: auto;
        color: #ee0000;
        margin-left: 8.4%;
      }
    }

    .second-line {
      margin-top: calc(20px);
      width: calc(100%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .SelectT {
          width: 100%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        .SelectDesk {
          width: 91%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8%;
          display: inline-block;
          margin-right: 5px;
        }
      }

      .left-01 {
        display: inline-block;
        width: 90.5%;

        vertical-align: top;

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: calc(25%);
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: 90.7%;
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        height: 100px;
        color: #ee0000;
        margin-left: 8.4%;
      }
    }

    .third-line {
      margin-top: calc(20px);
      width: calc(100%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .SelectT {
          width: 100%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        .SelectDesk {
          width: 91%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 11%;
          display: inline-block;
          margin-right: 5px;
        }
      }

      .left-01 {
        display: inline-block;
        width: 90.5%;

        vertical-align: top;

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          height: calc(25%);
          line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: 90.7%;
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        height: 100px;
        color: #ee0000;
        margin-left: 8.4%;
      }
    }

    .compare-line {
      margin-top: calc(10px);
      width: calc(93%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 43%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8.5%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .service-line {
      margin-top: calc(200px);
      width: calc(93%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 43%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 8.5%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .workleft-1 {
      height: 33px;
      margin-top: 200px;
      width: 100%;

      .workleft-11 {
        font-size: 12px;
        display: flex;

        .RadioGroup {
          color: #00050e;
          margin-top: 4px;
          width: 30%;
        }

        .left-12-Select {
          width: 30%;
          display: inline-block;
        }

        p {
          color: #00050e;
          width: 8%;
          margin-right: calc(20px);
          padding-top: 5px;
          font-size: 14px;
        }
      }
    }

    .workleft-6 {
      height: 33px;
      margin-top: 445px;
      width: 100%;

      .workleft-66 {
        font-size: 12px;
        display: flex;

        .RadioGroup {
          color: #00050e;
          margin-top: 4px;
          width: 30%;
        }

        .left-66-Select {
          width: 30%;
          display: inline-block;
        }

        p {
          color: #00050e;
          width: 8%;
          margin-right: calc(20px);
          padding-top: 5px;
          font-size: 14px;
        }
      }
    }

    .workleft-2 {
      position: absolute;
      width: 73.8%;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleft-3 {
      position: absolute;
      width: 99%;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleft-4 {
      position: absolute;
      margin-left: 50%;
      width: 49%;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleftCompare {
      margin-top: calc(10px);

      .knowledge {
        margin: 10px 5px 5px 120px;
        width: 125px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }

      .submit {
        margin: 10px 5px 5px 5px;
        width: 80px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }
    }
  }

  .workcenter {
    width: 30%;
    height: 100%;

    i {
      cursor: pointer;
    }

    .center-01 {
      color: #00050e;
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    .center-02 {
      height: 580px;

      .center-03 {
        height: 100%;
        overflow: auto;
        width: 300px;

        /deep/ .ivu-table {
          width: inherit;
          height: 100%;
          max-width: 100%;
          overflow: hidden;
          color: #3871f1;
          font-size: 14px;
          background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }
}

.sum-card-box2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
}
</style>
